<template>
	<i-switch ref="sw"
	    size="large"
	    v-bind="$attrs"
	    v-on="editEvents"
	    :disabled="!cellEditing || $attrs.readonly"
	    :value="value"
	    :trueValue="trueValue"
	    :falseValue="falseValue"
	    @input="onChange">
		<span slot="open">{{ trueText }}</span>
		<span slot="close">{{ falseText }}</span>
	</i-switch>
</template>
<script>
import mixin from './mixin'
import iSwitch from '../switch'

export default {
	mixins: [mixin],

	name: "CellSwitch",

	props: {
		optionList: {
			type: [Array, Function],
			default: () => []
		},
		trueValue: {
			type: [String, Number, Boolean],
			default: 1
		},
		falseValue: {
			type: [String, Number, Boolean],
			default: 0
		},
	},

	components: {
		iSwitch,
	},

	computed: {
		options() {
			var list = this.optionList

			if (typeof list == "function") {
				list = list(this.getContext())
			}

			return list
		},

		trueText() {
			var t = this.options.find(v => v.id == this.trueValue)

			return t ? t.text : ''
		},

		falseText() {
			var t = this.options.find(v => v.id == this.falseValue)

			return t ? t.text : ''
		}
	}
}
</script>